// Saat REACT_APP_GATEWAY_SSL= true, baseURL tidak menyertakan port (pakai port default 443).
// Saat false (atau tidak diset), port tetap disertakan.
// Trailing slash pada ip (mis. gateway path "https://host/be-emr-master/") dibuang supaya
// penggabungan manual seperti `${baseUrlX}/path` tidak menghasilkan double slash.
export const buildApiBaseUrl = (ip, port) => {
  const useSsl = process.env.REACT_APP_GATEWAY_SSL === "true"
  const host = (ip ?? "").replace(/\/+$/, "")
  return useSsl ? host : `${host}:${port}`
}
